import * as React from 'react';
export const IcBull = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.42 8.11c.081-.061.158-.128.23-.2A5.85 5.85 0 0021 4a1 1 0 00-1.89-.42A3.38 3.38 0 0116 5H8a3.41 3.41 0 01-3.11-1.45A1 1 0 003.79 3 1 1 0 003 4a5.87 5.87 0 001.31 4c.08.08.17.14.25.21A2.24 2.24 0 003 10.25a.76.76 0 00.75.75h1.5c.256-.001.51-.049.75-.14V14a4.92 4.92 0 013-1h6a4.92 4.92 0 013 1v-3.14c.24.091.494.139.75.14h1.5a.76.76 0 00.75-.75 2.25 2.25 0 00-1.58-2.14zM9 11a1 1 0 110-2.001 1 1 0 010 2zm6 0a1 1 0 110-2.002A1 1 0 0115 11zm0 4H9a3 3 0 000 6h6a3 3 0 000-6z'
      fill='currentColor'
    />
  </svg>
);
